import { ROLE_CATALOG } from '@application/access/roleCatalogContract';

/** Rôles autorisés à écrire une entrée module_data — identique en local et en remote. */

const WRITE = ROLE_CATALOG.module_data_write;
const COMPTA_NAMESPACES = new Set(WRITE.comptable.namespaces);
const COMPTA_PREFIXES = WRITE.comptable.prefixes;
const SALARIE_NAMESPACES = new Set(WRITE.salarie.namespaces);

export function comptablePeutEcrireModuleData(namespace: string): boolean {
  if (COMPTA_NAMESPACES.has(namespace)) return true;
  return COMPTA_PREFIXES.some((p) => namespace === p || namespace.startsWith(p));
}

export function moduleDataWriteRoles(namespace: string): readonly string[] {
  const roles = new Set<string>(WRITE.base);
  if (comptablePeutEcrireModuleData(namespace)) roles.add('comptable');
  if (SALARIE_NAMESPACES.has(namespace)) roles.add('salarie');
  return [...roles];
}

export function canWriteModuleData(role: string | undefined, namespace: string): boolean {
  if (!role) return false;
  return moduleDataWriteRoles(namespace).includes(role);
}
